<div class="menu-component">
  <div class="close-menu-container">
    <button class="close-menu" (click)="closeMenu()">
      <i class="fas fa-bars"></i>
      メニューを閉じる
    </button>
  </div>
  <mat-selection-list [multiple]="false" class="pos-menu-selection-list">
    <div mat-subheader class="menu-title">
      <i class="fas fa-shopping-cart"></i>
      商品マスタ
    </div>
    <mat-list-option
      #goods
      *ngFor="let opt of menuItems[0]"
      class="menu-item"
      (click)="changedMenuItem(opt.path)"
      [value]="opt.path"
      [selected]="opt.initSelected"
    >
      {{ opt.title }}
    </mat-list-option>
    <div mat-subheader class="menu-title">
      <i class="far fa-calendar-alt fa-lg"></i>
      カレンダマスタ
    </div>
    <mat-list-option
      #calendar
      *ngFor="let opt of menuItems[1]"
      class="menu-item"
      (click)="changedMenuItem(opt.path)"
      [value]="opt.path"
      [selected]="opt.initSelected"
    >
      {{ opt.title }}
    </mat-list-option>
    <div mat-subheader class="menu-title">
      <i class="fas fa-store-alt"></i>
      店舗マスタ
    </div>
    <mat-list-option
      #store
      *ngFor="let opt of menuItems[2]"
      class="menu-item"
      (click)="changedMenuItem(opt.path)"
      [value]="opt.path"
      [selected]="opt.initSelected"
    >
      {{ opt.title }}
    </mat-list-option>
    <div mat-subheader class="menu-title">
      <i class="fas fa-user-alt"></i>
      チェーンマスタ
    </div>
    <mat-list-option
      #reference
      *ngFor="let opt of menuItems[3]"
      class="menu-item"
      (click)="changedMenuItem(opt.path)"
      [value]="opt.path"
      [selected]="opt.initSelected"
    >
      {{ opt.title }}
    </mat-list-option>
    <div mat-subheader class="menu-title">
      <i class="fas fa-user-alt"></i>
      権限マスタ
    </div>
    <mat-list-option
      #reference
      *ngFor="let opt of menuItems[4]"
      class="menu-item"
      (click)="changedMenuItem(opt.path)"
      [value]="opt.path"
      [selected]="opt.initSelected"
    >
      {{ opt.title }}
    </mat-list-option>
  </mat-selection-list>
  <div class="menu-footer"></div>
</div>
